module.exports = __webpack_public_path__ + "img/icon_secChoice_03.cd455050.png";